module.exports = __webpack_public_path__ + "media/images/features/5/history-4-4b626f85557a51111e49fd222772602a.jpg";